import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
// import { PageHeader } from '@/components/ui/PageHeader'
import { Suspense, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { useProjectsOrganisationFilter } from '../ProjectsOrganisationFilterContext'
import { useUserLinkedOrganisations, useUserLinkedProjects } from '../useUserLinkedProjects'
import { ProjectsGrid, ProjectsGridLoading } from './ProjectsGrid'

export function ProjectsHome() {
  return (
    <QueryErrorBoundary errorMessage="Failed to fetch projects">
      <ProjectsHomeContent />
    </QueryErrorBoundary>
  )
}

function ProjectsHomeContent() {
  const navigate = useNavigate()
  const projects = useUserLinkedProjects()
  const organisations = useUserLinkedOrganisations()
  const { /* organisationFilter, */ selectedOrganisation } = useProjectsOrganisationFilter(organisations)

  const activeOrganisation = useMemo(() => {
    if (!selectedOrganisation) {
      return undefined
    }

    return organisations.find((org) => org.name === selectedOrganisation)
  }, [organisations, selectedOrganisation])

  const handleProjectCreated = useCallback(
    (projectId: number) => {
      navigate(`/projects/${projectId}`)
    },
    [navigate]
  )

  return (
    <div className="px-5">
      {/* <PageHeader
        title={
          <span className="inline-flex items-center gap-2 text-xl">
            {organisationFilter ? <span>{organisationFilter}</span> : ''}
            <span>Projects</span>
          </span>
        }
        className="px-3"
      /> */}
      <TablePageContainer fullHeight>
        {projects.length === 0 ? (
          <p className="px-3 py-8 text-muted-foreground">You do not have any linked projects yet.</p>
        ) : (
          <Suspense fallback={<ProjectsGridLoading />}>
            <ProjectsGrid
              organisationFilter={selectedOrganisation}
              activeOrganisation={activeOrganisation}
              onProjectCreated={handleProjectCreated}
            />
          </Suspense>
        )}
      </TablePageContainer>
    </div>
  )
}
